import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheckCircle, FiAlertCircle } = FiIcons;

function StatusMessage({ message, type = 'success' }) {
  if (!message) return null;

  return (
    <div className={`status-message ${type}`} role="status">
      <SafeIcon icon={type === 'error' ? FiAlertCircle : FiCheckCircle} />
      <span>{message}</span>
    </div>
  );
}

export default StatusMessage;